/**
 * Created by wjjn3481 on 2017/4/17.
 */

function dateFormat (date, format = 'yyyy-MM-dd') {
    // date = null或者 ''这些情况都直接返回''
    if (!date) {
        return ''
    }

    // 兼容safari
    let dateReplace = typeof date === 'string' ? date.replace(/-/g, '/') : date

    // 是date对象就是跳过
    if (!(date instanceof Date)) {
        date = new Date(dateReplace)
    }

    if (String(date) === 'Invalid Date') {
        return ''
    }

    let map = {
        'M+': date.getMonth() + 1,  // month
        'd+': date.getDate(),       // day
        'h+': date.getHours(),      // hour
        'm+': date.getMinutes(),    // minute
        's+': date.getSeconds(),                     // second
        'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
        'S': date.getMilliseconds()                  // millisecond
    }

    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }

    for (let key in map) {
        if (new RegExp('(' + key + ')').test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? map[key] : ('00' + map[key]).substr(('' + map[key]).length))
        }
    }

    return format
}

export {
    dateFormat
}


// WEBPACK FOOTER //
// ./src/modules/tools.js